import { createContext } from "react";

export const StatusContext =  createContext()
